module.exports = __webpack_public_path__ + "static/media/greenhouse2Step9-4.a265bcab.png";